/**
 * In the PHONE APP, signed out: a strip under the header — sign in for the full app (the user,
 * 2026-10-26: "on the mobile when the user is not signed in you can show a second header: log in
 * to the app to gain full access"). The rows, a rave's schedule and map need no account; saving,
 * rides and reminders do. One press: the sign-in, and back to this page. Gone once signed in;
 * never on the website, the sign-in host, a preview or the wizard's frame.
 */
import { inNativeApp } from '@/lib/nativeBridge';
import { isFramed } from '@/lib/framed';
import { inPreview } from '@/lib/preview';
import { isLoginHost } from '@/lib/tenant';
import { askToSignIn } from '@/lib/signInFirst';
import { useT } from '@/i18n';
import { useAuth } from './AuthProvider';
import { useTenant } from './TenantProvider';
import { useInviteFrom } from './useInvite';
import './SignInStrip.css';

export function SignInStrip() {
  const tr = useT();
  const { user, loading } = useAuth();
  const { tenant } = useTenant();
  // A friend's invite to THIS rave (2026-10-27): "Sign in to join Dana at OZORA 2026" — on the
  // website too, where the strip is otherwise the phone app's alone.
  const invite = useInviteFrom((tenant?.editions ?? []).map((e) => e.id));
  if (user || loading || isFramed() || inPreview() || isLoginHost()) return null;
  if (!inNativeApp() && !invite) return null;
  return (
    <div className="sign-in-strip" role="region" aria-label={tr('Sign in')}>
      <span className="sign-in-strip-text">
        {invite
          ? tr('Sign in to join {name} at {rave}', { name: invite.inviterName, rave: invite.editionName })
          : tr('Sign in to gain full access')}
      </span>
      <button type="button" className="sign-in-strip-go" onClick={() => askToSignIn()}>{tr('Sign in')}</button>
    </div>
  );
}
